import { UnleashClient } from 'unleash-proxy-client'
import { unleashConfig } from './app.config'
import { UNLEASH_INIT } from '@/store/action-types'

export const initUnleash = (store) => {
  const unleash = new UnleashClient(unleashConfig)
  // Used to set the context fields, shared with the Unleash Proxy
  unleash.updateContext({ userId: global.realm_tenant })

  // Start the background polling
  unleash.start().then((e) => {
    global.unleash = unleash
    store.dispatch(UNLEASH_INIT)
  })
}
